import React from 'react';
import ScenarioSharePage from './scenario-share.$token.jsx';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Code, Container, VStack } from '@chakra-ui/react';

// Check if we're in Vite proxy mode
const isViteProxy = () => {
  if (typeof window === "undefined") return false;
  // Only check for actual Vite HMR patterns, not just html-proxy in the path
  const url = window.location.href;
  const search = window.location.search;
  
  // Vite HMR uses specific query parameters and patterns
  return search.includes('html-proxy&index=') || 
         url.includes('/@vite/') || 
         url.includes('/@fs/') ||
         url.includes('/@id/');
};

function ScenarioShareWrapper() {
  // If we're in Vite proxy mode, don't render anything
  if (isViteProxy()) {
    return null;
  }

  return <ScenarioSharePage />;
}

class ScenarioShareErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ScenarioShare runtime error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxW="container.md" py={10}>
          <VStack spacing={4} align="stretch">
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              <Box>
                <AlertTitle>Scenario Share Runtime Error</AlertTitle>
                <AlertDescription>
                  The page failed while rendering. Please send this exact message to support.
                </AlertDescription>
              </Box>
            </Alert>
            <Code p={4} whiteSpace="pre-wrap">
              {this.state.error?.message || "Unknown runtime error"}
            </Code>
          </VStack>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default function ScenarioShareWrapperWithBoundary() {
  return (
    <ScenarioShareErrorBoundary>
      <ScenarioShareWrapper />
    </ScenarioShareErrorBoundary>
  );
}
